import React, { useState } from 'react';
import { Button, TextInput } from '@dsg-tech/homefield-react';

interface StoreSelectionFormProps {
  onSubmit: (storeNumber: number) => void;
  error?: string | null;
}

const StoreSelectionForm: React.FC<StoreSelectionFormProps> = ({ onSubmit, error }) => {
  const [inputValue, setInputValue] = useState<string>('');
  const [hasInput, setHasInput] = useState<boolean>(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const storeNum = parseInt(inputValue, 10);
    if (!Number.isNaN(storeNum)) {
      onSubmit(storeNum);
    }
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    const { value } = e.target;
    setInputValue(value);
    setHasInput(value.length > 0);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="store-selection-form hmf-mb-0 hmf-display-flex hmf-flex-column">
      <div className="form-group hmf-position-relative hmf-mb-0 hmf-pb-s">
        <div className="input-border">
          <TextInput
            name="storeNumber"
            id="storeNumber"
            type="number"
            value={inputValue}
            onChange={handleInputChange}
            placeholder=" "
            label="Store Number"
            error={!!error}
            helperText={error ?? undefined}
          />
        </div>
      </div>
      <Button
        type="submit"
        variant="primary"
        size="medium"
        disabled={!hasInput}
        text="Submit"
        className={`submit-button ${hasInput ? 'active' : ''}`}
      />
    </form>
  );
};

export default StoreSelectionForm;
